/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-unresolved */
/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  saveJointLifeAddendumDetails,
  saveJointMemberId,
  setJointFreezeData,
  setJointLifeAddendumDetails,
  setJointLifeCovidAndNriDetails,
  setJointReviewData
} from "src/redux/Actions/jointLifeAddendum";
import { AppState } from "src/utils/hooks/useAppSelector";
import {
  bindAssignmentPayload,
  bindJointFreezePayload,
  bindJointFreezePayloadForRedux,
  bindJointLifeAPIData,
  bindJointMemberPayload,
  bindProportionatePayload,
  bindProposerAPIData,
  bindProposerAddressPayload,
  bindProposerGeneralPayload,
  mapNomineeDetails
} from "src/helpers/FormDetails";
import {
  setJointMemberDetails,
  setMemberDetails,
  setProportionateMemberDetails
} from "src/services/LeadInfo";
import getNomineeDetails, { deleteNomineeDetails } from "src/services/FormDetails/NomineeDetails";
import { getFullName } from "src/helpers/FormDetails/ProposalDetails/resources";
import { loanDetailsUpdate } from "src/services/FormDetails";
import { CoverType, JointCoverageType } from "src/config/constant";
import {
  saveProposerDetails as saveProposerDetailsAction,
  setProposerDetails,
  setProposerReviewData
} from "../Actions/proposerDetails";
import {
  saveLoanDetails as saveLoanDetailsAction,
  setLoanDetails,
  setRiderSelectionLocked
} from "../Actions/loanDetails";
import {
  saveAssignmentClauseDetails as saveAssignmentClauseDetailsAction,
  setAssignmentClause
} from "../Actions/assignmentClause";
import {
  SET_JOINT_ADDENDUM_STATE,
  SET_TOAST_ERROR,
  saveCovidAndNriDetailsAction,
  saveGeneralDetailsAction,
  saveNewLeadDetailsAction,
  setCovidAndNriDetails,
  setIsProportionateParentLead,
  setLeadDetails,
  setMasterLoading,
  setPostMEFLoading,
  setProductId,
  setStepDetails,
  setStaffMember,
  setAssignmentFlagStatus
} from "../Actions/common";
import {
  saveMedicalDetailsAction,
  saveMedicalV2DetailsAction,
  setMedicalAndLifeStyle,
  setMedicalV2DetailsAction
} from "../Actions/medicalLifeStyle";
import { mapRiderMasterData, mapRuleEngineData, populateRange } from "../Reducers/MasterReducer";
import {
  AddressDetails,
  SecondaryDetails
} from "../../helpers/FormDetails/ProposalDetails/interfaces";
import { setQuestionnaire } from "../Actions/Masters";

export function saveAssignmentClauseDetails(
  data: any,
  addressData: SecondaryDetails,
  leadId: string
) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    const { masterdata_reducer } = getState();
    dispatch(saveAssignmentClauseDetailsAction(data, masterdata_reducer, leadId, addressData));
  };
}

export function saveProposerDetails(data: any, leadId: string) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    const { masterdata_reducer, proposerDetails } = getState();
    try {
      dispatch(setMasterLoading(true));
      const proposerBinding = await bindProposerAPIData(proposerDetails, data, masterdata_reducer);
      dispatch(saveProposerDetailsAction(proposerBinding, leadId));
      dispatch(
        saveAssignmentClauseDetails(data, proposerBinding?.obj?.address?.address!, leadId || "")
      );
    } finally {
      dispatch(setMasterLoading(false));
    }
  };
}
export function savemedicalDetails(data: any, leadId: string) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>) => {
    dispatch(saveMedicalDetailsAction(data, leadId));
  };
}

export function saveMedicalDetailsV2(data: any, leadId: string) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>) => {
    dispatch(saveMedicalV2DetailsAction(data, leadId));
  };
}

export function saveJointMemberDetails(data: any, leadId: string) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    const { masterdata_reducer, jointLifeAddendum } = getState();
    try {
      dispatch(setMasterLoading(true));
      const jointBinding = await bindJointLifeAPIData(jointLifeAddendum, data, masterdata_reducer);
      dispatch(saveJointLifeAddendumDetails(jointBinding, leadId));
    } finally {
      dispatch(setMasterLoading(false));
    }
  };
}

export function saveLoanDetails(data: any, leadId: string) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    const { masterdata_reducer } = getState();
    dispatch(saveLoanDetailsAction(data, masterdata_reducer, masterdata_reducer?.riders, leadId));
  };
}

export function saveGeneralDetails(data: any, leadId: string) {
  return function (dispatch: ThunkDispatch<any, unknown, AnyAction>) {
    dispatch(saveGeneralDetailsAction(data, leadId));
  };
}

export function saveCovidAndNriDetails(data: any, leadId: string) {
  return function (dispatch: ThunkDispatch<any, unknown, AnyAction>) {
    dispatch(saveCovidAndNriDetailsAction(data, leadId));
  };
}

export function setProposerGeneralPostDetails(data: any, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));
      const {
        common: { leadId, assignmentStepperFlag },
        proposerDetails: { memberId, general },
        masterdata_reducer: { coverType },
        loanDetails
      } = getState();
      const payload = bindProposerGeneralPayload(data, general!);
      payload.requirementFlag = data.requirementFlag;
      const apiToCall = [setMemberDetails(memberId as string, payload)];
      if (assignmentStepperFlag) {
        dispatch(setAssignmentClause({ assignor: `${data?.firstName} ${data?.lastName}` }));
      }
      if (data?.isJointJourney) {
        const jointPayload = bindJointFreezePayload(data, leadId);
        if (assignmentStepperFlag) {
          dispatch(
            setAssignmentClause({
              assignorJoint: `${jointPayload?.firstName} ${jointPayload?.lastName}`
            })
          );
        }
        apiToCall.push(setJointMemberDetails(jointPayload));
      } else if (data?.isProportionateLife) {
        const proportionatePayload = bindProportionatePayload(data, leadId);
        apiToCall.push(setProportionateMemberDetails(proportionatePayload));
        // console.log("proportionate payload", proportionatePayload);
      }

      // concurrent API call for proposer and conditional joint freezed fields
      const response = await Promise.all(apiToCall);
      // console.log("promise response", response);

      // await setMemberDetails(memberId as string, payload);

      // adds joint addendum section on stepper, and save data to redux
      if (data?.isJointJourney) {
        dispatch(saveJointMemberId((response[response?.length - 1] as any)?.data?.id));
        const jointPayloadForRedux = bindJointFreezePayloadForRedux(data);
        dispatch(setJointFreezeData(jointPayloadForRedux));
        dispatch(SET_JOINT_ADDENDUM_STATE({ isJointState: JointCoverageType.YES }));
        dispatch(
          setLoanDetails({
            ...loanDetails,
            plan: {
              ...loanDetails.plan,
              coverOption: coverType.joint,
              coverOptionCode: CoverType.JOINT
            }
          })
        );
      }
      // saves loan amount, cover type, etc into redux store
      else if (data?.isProportionateLife) {
        dispatch(setIsProportionateParentLead(true));
        dispatch(
          setLoanDetails({
            ...loanDetails,
            loan: {
              ...loanDetails.loan,
              loanAmount: (response[response?.length - 1] as any)?.data?.loanAmount || 0,
              noOfCoBorrowers: data?.proportionate?.length,
              share: data?.primaryProportionatePercent
            },
            plan: {
              ...loanDetails.plan,
              coverOption: coverType.proportionate,
              coverOptionCode: CoverType.PROPORTIONATE
            }
          })
        );
      }

      // after submitting the proposer details joint/proportionate
      // checkbox should not appear, or persist in store
      Object.assign(data, {
        isJointJourney: false,
        isProportionateLife: false
      });
      dispatch(
        setProposerDetails({
          general: data
        })
      );

      // update the stepper to one the ahead
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "Details Saved Successfully"
        })
      );
    } catch (error: any) {
      const errorMessage = error.message || "Please Try Again. Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function setProposerAddressPostDetails(data: AddressDetails, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));
      const {
        proposerDetails: { memberId, address },
        common: { assignmentStepperFlag }
      } = getState();
      const payload = bindProposerAddressPayload(data, address!);
      await setMemberDetails(memberId as string, payload);
      dispatch(
        setProposerDetails({
          address: data
        })
      );
      if (assignmentStepperFlag) {
        dispatch(
          setAssignmentClause({ place: data?.address?.city, placeCode: data?.address?.cityCode })
        );
      }
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "Address Details Saved Successfully"
        })
      );
    } catch (error: any) {
      const errorMessage = error.message || "Please Try Again. Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function setProposerMedicalLifestylePostDetails(data: any, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));
      const {
        proposerDetails: { memberId },
        medicalAndLifeStyle
      } = getState();
      await setMemberDetails(memberId as string, { medicalAndLifeStyle: data });
      if (data?.version === 3) {
        dispatch(setMedicalV2DetailsAction(data));
      } else dispatch(setMedicalAndLifeStyle({ ...medicalAndLifeStyle, medicalDetails: data }));
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 2000,
          type: "success",
          message: "Medical & Lifestyle Details Saved Successfully"
        })
      );
    } catch (error: any) {
      const errorMessage = error.message || "Please Try Again. Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function setCovidNRIPostDetails(data: any, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));
      const payload = {
        covidDetails: {
          covidTest: data?.covidTest,
          covidVaccineDates: data?.covidVaccineDates
        },
        NRIDetails: {
          nriDetails: data?.nriDetails,
          bankDetails: data?.bankDetails,
          occupationDetails: data?.occupationDetails,
          otherCountryTravel: data?.otherCountryTravel,
          policyDetails: data?.policyDetails,
          residence: data?.residence,
          salaried: data?.salaried,
          selfEmployed: data?.selfEmployed
        }
      };
      const {
        proposerDetails: { memberId }
      } = getState();
      await setMemberDetails(memberId as string, payload);
      dispatch(setCovidAndNriDetails(data));
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "NRI Details Saved Successfully"
        })
      );
    } catch (error: any) {
      const errorMessage = error.message || "Please Try Again. Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function setJointMemberPostDetails(leadId: any, data: any, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));
      const {
        jointLifeAddendum: {
          memberId,
          member,
          address,
          existingPolicy,
          isAddressProposer,
          jointCoBorrowerFlag,
          jointGuarantorFlag,
          jointHousewifeFlag,
          jointPrimaryBorrowerFlag
        },
        masterdata_reducer
      } = getState();
      const payload = bindJointMemberPayload(
        data,
        {
          member,
          address,
          existingPolicy,
          isAddressProposer,
          jointCoBorrowerFlag,
          jointGuarantorFlag,
          jointHousewifeFlag,
          jointPrimaryBorrowerFlag
        },
        masterdata_reducer
      );
      payload.requirementFlag = !!data.member.requirementFlag;
      await loanDetailsUpdate({ values: data, section: "jointGeneralDetails", leadId });
      await setMemberDetails(memberId as string, payload);
      dispatch(setJointLifeAddendumDetails(data));
      dispatch(
        setAssignmentClause({
          assignorJoint: getFullName(data?.member?.firstName, data?.member?.lastName)
        })
      );
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "Joint Member Details Saved Successfully"
        })
      );
    } catch (err: any) {
      const errorMessage = err.message || "Please Try Again. Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function setJointMedicalLifestylePostDetails(data: any, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));
      const { jointLifeAddendum } = getState();
      await setMemberDetails(jointLifeAddendum?.memberId as string, {
        medicalAndLifeStyle: data
      });
      dispatch(
        setJointLifeAddendumDetails({
          ...jointLifeAddendum,
          ...(data?.version === 3 ? { medicalDetailsV2: data } : { medicalDetails: data })
        })
      );
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "Joint Medical & Lifestyle Details Saved Successfully"
        })
      );
    } catch (err: any) {
      const errorMessage = err.message || "Please Try Again. Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function setJointCovidAndNriDetails(data: any, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));
      const {
        jointLifeAddendum: { memberId }
      } = getState();
      const payload = {
        covidDetails: {
          covidTest: data?.covidTest,
          covidVaccineDates: data?.covidVaccineDates
        },
        NRIDetails: {
          nriDetails: data?.nriDetails,
          bankDetails: data?.bankDetails,
          occupationDetails: data?.occupationDetails,
          otherCountryTravel: data?.otherCountryTravel,
          policyDetails: data?.policyDetails,
          residence: data?.residence,
          salaried: data?.salaried,
          selfEmployed: data?.selfEmployed
        }
      };
      // const payload = bindJointMemberPayload(data, medicalDetails);
      // console.log("joint member payload", memberId, data);
      await setMemberDetails(memberId as string, payload);
      dispatch(setJointLifeCovidAndNriDetails(data));
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "NRI Details Saved Successfully"
        })
      );
    } catch (err: any) {
      const errorMessage = err.message || "Please Try Again. Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function setReviewDetails(response: Record<string, any>, leadId: string) {
  return (dispatch: ThunkDispatch<any, unknown, AnyAction>) => {
    dispatch(setProductId(response?.productId));
    dispatch(setStaffMember(response?.staffMember));
    dispatch(setLeadDetails(response));
    dispatch(setProposerReviewData(response));
    const jointMemberData = response?.Members?.filter((ele: any) => ele.isJointMember === true)[0];
    if (jointMemberData) dispatch(setJointReviewData(response));
    dispatch(SET_JOINT_ADDENDUM_STATE({ isJointState: response?.jointLifeCoverage }));
    dispatch(saveGeneralDetails(response, leadId || ""));
    dispatch(saveCovidAndNriDetails(response, leadId || ""));
    // dispatch(saveLoanDetails(response, leadId || ""));
    dispatch(savemedicalDetails(response, leadId || ""));
    dispatch(saveMedicalDetailsV2(response, leadId || ""));
    dispatch(setAssignmentFlagStatus(response.assignmentFlag));
    dispatch(setRiderSelectionLocked(response?.riderFlag));
    const assignmentData = bindAssignmentPayload(response);
    dispatch(setAssignmentClause(assignmentData));
    dispatch(setQuestionnaire(response?.RuleEngine?.QuestionnairesAssociations));
    const productMaster = response.RuleEngine?.productMaster || {};
    const riderMaster = response.RuleEngine?.riderMaster || {};
    dispatch(
      saveLoanDetailsAction(
        response,
        mapRuleEngineData({
          ...productMaster,
          ...{
            moratoriumPeriod: [
              { label: 0, value: 0 },
              ...populateRange(productMaster?.moratoriumPeriod)
            ],
            moratoriumPeriodWithoutInterest: [
              { label: 0, value: 0 },
              ...populateRange(productMaster?.moratoriumPeriodWithoutInterest)
            ]
          },
          ...{
            term: populateRange(productMaster?.term),
            policyTerm: populateRange(productMaster?.policyTerm)
          }
        }),
        mapRiderMasterData(riderMaster),
        leadId
      )
    );
  };
}
export function setNomineeDetails(data: any, setStep: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    try {
      dispatch(setPostMEFLoading(true));

      const {
        proposerDetails: { memberId },
        masterdata_reducer
      } = getState();
      const updatedNomineeDetails = await getNomineeDetails({ memberId, nomineeDetails: data });
      if (updatedNomineeDetails.error) throw new Error();
      console.log(
        mapNomineeDetails(updatedNomineeDetails.data, masterdata_reducer),
        "updatedNomineeDetails"
      );
      dispatch(
        setProposerDetails({
          nominee: { nominee: mapNomineeDetails(updatedNomineeDetails.data, masterdata_reducer) }
        })
      );
      dispatch(setStepDetails(setStep));
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "Nominee Details Saved Successfully"
        })
      );
    } catch (error: any) {
      const errorMessage = error.message || "Please Try Again. Nominee Details Not Saved";
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: errorMessage
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function deleteNominee(nomineeId: any) {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>) => {
    try {
      dispatch(setPostMEFLoading(true));
      const updatedNomineeDetails = await deleteNomineeDetails(nomineeId);
      if (updatedNomineeDetails.error) throw new Error();
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          duration: 2000,
          message: "Nominee Details Deleted Successfully"
        })
      );
    } catch (error) {
      dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: "Please Try Again. Nominee Details are Not Deleted"
        })
      );
    } finally {
      dispatch(setPostMEFLoading(false));
    }
  };
}

export function saveNewLeadDetails(data: any) {
  return function (dispatch: ThunkDispatch<any, unknown, AnyAction>) {
    dispatch(saveNewLeadDetailsAction(data));
  };
}

export function setAssignmentId() {
  return async (dispatch: ThunkDispatch<any, unknown, AnyAction>, getState: () => AppState) => {
    const { assignmentClauseDetails } = getState();
    dispatch(
      setAssignmentClause({
        ...assignmentClauseDetails,
        applicationId: "",
        witnessName: "",
        address: "",
        pincode: "",
        occupation: "",
        occupationCode: ""
      })
    );
  };
}
